import {
  EG_CITIES,
  SHIPPING_OPTIONS,
  PAYMENT_METHODS,
  LANGUAGES,
  LIMITS,
  PHOTO_ACCEPT,
  EXPRESS_CITIES,
  ADDONS,
  GIFT_MESSAGE_MAX
} from '../../constants/storefrontOrderConstants';

export {
  EG_CITIES,
  SHIPPING_OPTIONS,
  PAYMENT_METHODS,
  LANGUAGES,
  LIMITS,
  PHOTO_ACCEPT,
  EXPRESS_CITIES,
  ADDONS,
  GIFT_MESSAGE_MAX
};

// Language suffixes stripped from product handles before rebuilding the SKU.
// Ported verbatim (including case-insensitivity) from generateCustomSKU in
// Snaps-Shopify-Theme/sections/order-form.liquid.
const LANGUAGE_SUFFIX_PATTERN = /-ar$|-de$|-fr$|-es$|-it$|-en$/i;
const PAGES_TYPE_SUFFIX_PATTERN = /-short$|-long$/i;

/**
 * Build the generated SKU for a story, mirroring generateCustomSKU on the
 * storefront. The backend parses this exact format on webhook import.
 *
 * - Language suffix (-ar/-de/-fr/-es/-it/-en) and pages-type suffix
 *   (-short/-long) are removed from the handle, then re-added only when
 *   they differ from the defaults (langCode !== 'en', pagesType !== 'long').
 * - Age is included only when truthy.
 *
 * @param {Object} params
 * @param {string} params.handle - Product handle (may already carry suffixes).
 * @param {string|null} params.age - Story age, or null.
 * @param {'short'|'long'} params.pagesType - Pages type.
 * @param {string} params.languageCode - ISO language code.
 * @param {boolean} [params.hasGiftNote=false] - Appends the `giftnote` part.
 * @param {boolean} [params.hasGiftBox=false] - Appends the `gift` part.
 * @returns {string}
 */
export function buildGeneratedSku({
  handle,
  age,
  pagesType,
  languageCode,
  hasGiftNote = false,
  hasGiftBox = false
}) {
  let storyName = handle || '';
  storyName = storyName.replace(LANGUAGE_SUFFIX_PATTERN, '');
  storyName = storyName.replace(PAGES_TYPE_SUFFIX_PATTERN, '');

  const skuParts = [storyName];

  if (age) {
    skuParts.push(age);
  }

  if (pagesType && pagesType !== 'long') {
    skuParts.push(pagesType);
  }

  if (languageCode && languageCode !== 'en') {
    skuParts.push(languageCode);
  }

  // Per-story gift extras, ported from generateCustomSKU in order-form.liquid.
  // Suffixes are appended verbatim and never deduplicated (a handle ending in
  // `-gift` with a gift box still gets another `-gift` part).
  if (hasGiftNote) {
    skuParts.push('giftnote');
  }
  if (hasGiftBox) {
    skuParts.push('gift');
  }

  return skuParts.join('-');
}
